<script>
export default {
  methods: {
    productoNombre(id) {
      const item = this.$store.getters['Productos/all'].find(item => item.id === id)
      return item ? item.nombre : 'Sin producto'
    },
    productoCoeficiente(id) {
      const item = this.$store.getters['Productos/all'].find(item => item.id === id)
      //console.log(item)
      return item ? item.coeficiente : 1;
    }
  }
};
</script>
